export const ACCOUNT_URL = "https://account.fastmodelsports.com/";
